<div class="flex flex-col gap-2 bg-white rounded p-2">
  <h3 class="text-base font-medium text-gray-90">
    {{ 'RegisterService::Asset:Details' | abpLocalization }}
  </h3>
  <div>
    <label class="form-label text-xs" for="asset-manufacturer-id">
      {{ 'RegisterService::Manufacturer' | abpLocalization }}
    </label>
    <input
      id="asset-manufacturer-id"
      [value]="asset?.manufacturerName ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>
  <div>
    <label class="form-label text-xs" for="asset-model-id">
      {{ 'RegisterService::Model' | abpLocalization }}
    </label>
    <input
      id="asset-model-id"
      [value]="asset?.model?.name ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>
  <div>
    <label class="form-label text-xs" for="asset-noise">
      {{ 'RegisterService::Noise' | abpLocalization }}(db)
    </label>
    <input
      id="asset-noise"
      [value]="asset?.model?.noise ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>

  <div>
    <label class="form-label text-xs" for="asset-havRating">
      {{ 'RegisterService::HAVRating' | abpLocalization }}(m/s2)
    </label>
    <input
      id="asset-havRating"
      [value]="asset?.model?.havRating ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>

  <div>
    <label class="form-label text-xs" for="asset-weight">
      {{ 'RegisterService::Weight' | abpLocalization }}
    </label>
    <input
      id="asset-weight"
      [value]="asset?.model?.weight ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>

  <div>
    <label class="form-label text-xs" for="asset-atex">
      {{ 'RegisterService::ATEX' | abpLocalization }}
    </label>
    <input
      id="asset-atex"
      [value]="asset?.model?.atex ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>

  <div>
    <label class="form-label text-xs" for="asset-averageLitresPerHour">
      {{ 'RegisterService::AverageLitresPerHour' | abpLocalization }}
    </label>
    <input
      id="asset-averageLitresPerHour"
      [value]="asset?.model?.averageLitresPerHour ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>

  <div>
    <label class="form-label text-xs" for="asset-averageLoadKwh">
      {{ 'RegisterService::AverageLoadPerKmHour' | abpLocalization }}
    </label>
    <input
      id="asset-averageLoadKwh"
      [value]="asset?.model?.averageLoadKwh ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readOnly
    />
  </div>
  <div
    class="flex w-full justify-between bg-gray-30 rounded p-2 items-center gap-3"
    *ngIf="costCentreName"
  >
    <div class="flex items-center">
      <p class="text-gray text-sm">{{ 'RegisterService::CostCentre' | abpLocalization }}:</p>
      &nbsp;
      <p class="text-gray-90 text-sm">{{ costCentreName }}</p>
    </div>
    <div class="form-check min-w-max">
      <input
        type="checkbox"
        id="asset-is-known-as"
        (change)="changeStatus($event.target.checked)"
        [checked]="isCostCentreFixed"
        class="form-check-input"
      />
      <label for="asset-is-known-as" class="form-check-label">
        {{ 'RegisterService::IsFixed' | abpLocalization }}
      </label>
    </div>
  </div>
</div>
